const TealiumEventBuilder = require('../../analytics/tealium/builders/tealium-event-builder');

class FulfilmentSelectorPickupAddressController {
    constructor(settings, analyticsService, pickupAddressSearchService, fulfilmentSelectorService, moveFocus) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.pickupAddressSearch = pickupAddressSearchService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.pickupStores = [];

        this.storesPerPage = this.settings.fulfilmentSelector.pickupStoresPerPage;
        this.numberOfStoresToShow = this.storesPerPage;

        this.selectedStoreText = this.selectedAddress ? this.selectedAddress.AddressText : '';

        this.screenName = 'FulfilmentSelection';
        const event = new TealiumEventBuilder()
            .withScreenName(this.screenName)
            .withLabel('Fulfilment type toggle')
            .withValue('Pickup')
            .withEventName('modal_view')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .build();

        this.analyticsService.push(event);

        this.fulfilmentSelectorService.subscribeEscPushAnalytics(this.analyticsService, this.screenName);
    }

    getAddressText(item) {
        return item.AddressText;
    }

    setStores(stores) {
        this.pickupStores = stores;
        this.selectedStore = null;
        this.selectedStoreText = null;
    }

    onSelectStore(store) {
        if (this.selectedAddress && this.selectedAddress.AddressId !== store.AddressId) {
            const event = new TealiumEventBuilder()
                .withScreenName(this.screenName)
                .withLabel('Pickup store change')
                .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
                .withEventName('modal_interaction')
                .build();

            this.analyticsService.push(event);
        }
        this.selectedStore = store.AddressId;
        this.selectedStoreText = store.AddressText;
        this.setPickupAddress({ addr: store });
    }

    hasStores() {
        return !!this.pickupStores && this.pickupStores.length > 0;
    }

    hasMoreStores() {
        return this.hasStores() && this.numberOfStoresToShow < this.pickupStores.length;
    }

    viewMoreStores() {
        if (this.hasMoreStores()) {
            this.numberOfStoresToShow += this.storesPerPage;
        }
    }

    clearSearch() {
        this.searchPending = false;
        this.hasSearched = false;
        this.isSearching = false;
        this.searchString = '';
        this.setStores({ stores: [] });
    }

    resetSearch() {
        this.clearSearch();
        this.moveFocus('._pickupAddressSearch-input');
    }

    $onDestroy() {
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorPickupAddressController.$inject = ['Settings', 'AnalyticsService', 'PickupAddressSearchService', 'FulfilmentSelectorService', 'MoveFocus'];

const fulfilmentSelectorPickupAddressComponentDefinition = {
    bindings: {
        classModifier: '@?',
        setPickupAddress: '&',
        selectedAddress: '<?',
    },
    controller: FulfilmentSelectorPickupAddressController,
    template: require('./fulfilment-selector-pickup-address.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorPickupAddressController,
    fulfilmentSelectorPickupAddressComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-pickup-address.component.js